import { render, staticRenderFns } from "./ContactNumberLabel.vue?vue&type=template&id=7243ba79&"
import script from "./ContactNumberLabel.vue?vue&type=script&lang=ts&"
export * from "./ContactNumberLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports